var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header" }, [
      _vm._v(
        "\n    Details for " +
          _vm._s(_vm.value.firstName ? _vm.value.firstName : "Student") +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.fields, function(property, field) {
          return _c(
            "div",
            { staticClass: "col-sm-3" },
            [
              field == "classId"
                ? [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.labels["classId"]))
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.className))])
                  ]
                : field == "gender"
                ? [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.labels["gender"]))
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.gender))])
                  ]
                : field == "exemption"
                ? [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.labels["exemption"]))
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.exemption))])
                  ]
                : [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.labels[field]))
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.value[field]))])
                  ]
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-right mt-sm-2" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-outline-secondary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                return _vm.cancel()
              }
            }
          },
          [_vm._v("\n        Close\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-233f91ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233f91ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/view-student.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-233f91ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/view-student.vue
// module chunks = 0